export const RESIDUE_TYPE_NAMES = {
  rest: "Resto",
  organic: "Orgánico",
  glass: "Vidrio",
  plastic: "Plástico",
  paperAndCardboard: "Papel y cartón",
};
